"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseClass2 = require("./BaseClass");

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Product = function (_BaseClass) {
  _inherits(Product, _BaseClass);

  /**
   * Id des Tickets
   * @type {string}
   */

  /**
   * Ticketname
   * @type {string}
   */

  /**
   * Ident des Tickets
   * @type {string}
   */

  /**
   * Id der Matrix
   * @type {string}
   */

  /**
   * Id der MatrixFix
   * @type {string}
   */

  /**
   * Id des Startpunktes
   * @type {string}
   */

  /**
   * Id des Endpunktes
   * @type {string}
   */

  /**
   * Ident Haltestelle Von
   * @type {string}
   */

  /**
   * Ident Haltestelle Bis
   * @type {string}
   */

  /**
   * Ident Über
   * @type {string}
   */

  /**
   * Text von
   * @type {string}
   */

  /**
   * Text Bis
   * @type {string}
   */

  /**
   * Text Über
   * @type {string}
   */

  /**
   * Text Über 2
   * @type {string}
   */

  /**
   * durchfahrene Zonen
   * @type {array} of Zones
   */

  /**
   * Pricelevel
   * @type {string}
   */

  /**
   * Preis
   * @type {integer}
   */

  /**
   * Interwall der Zahlung
   * @type {string}
   */

  /**
   * Vertragsende
   * @type {date}
   */

  /**
   * Sind Mitfahrer erlaubt?
   * @type {boolean}
   */

  /**
   * Anzahl Mitfahrer Erwachsene
   * @type {integer}
   */

  /**
   * Anzahl Mitfaherer Kinder
   * @type {integer}
   */

  /**
   * Mindestalter für das Produkt
   * @type {integer}
   */
  function Product() {
    _classCallCheck(this, Product);

    var _this = _possibleConstructorReturn(this, (Product.__proto__ || Object.getPrototypeOf(Product)).call(this));

    _this.IdTicket = "";
    _this.TicketName = "";
    _this.TicketIdent = "";
    _this.IdMatrix = "";
    _this.IdMatrixFix = "";
    _this.IdFrom = "";
    _this.IdTo = "";
    _this.IdendTzFrom = "";
    _this.IdendTzTo = "";
    _this.IdendTzVia = "";
    _this.TzFromText = "";
    _this.TzToText = "";
    _this.TzViaText = "";
    _this.TzViaText2 = "";
    _this.TraversedZones = [];
    _this.PriceLevel = "";
    _this.Price = 0;
    _this.PaymentInterval = "";
    _this.ContractEnd = "";
    _this.FlagMultiUser = false;
    _this.MultiUserCountAdult = 0;
    _this.MultiUserCountChild = 0;
    _this.RequiredAge = 0;
    _this.FixedRoute = false;

    return _this;
  }
  /**
   * Feste Fahrtstrecke
   * @type {boolean}
   */


  return Product;
}(_BaseClass3.default);

exports.default = Product;